/*
 * @Author: wutt
 * @Date: 2020-11-16 11:57:17
 * @LastEditors: wutt
 * @LastEditTime: 2020-11-21 20:19:16
 * @Description: 
 * @FilePath: /DianZiDiTu/src/components/onlineMap/model/TDTServiceInfoJs.js
 */
/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-22 15:21:09
 * @LastEditTime : 2020-01-14 10:33:00
 * @LastEditors  : Please set LastEditors
 */

import AxiosConfig from "../../../config/AxiosConfigJs.js";
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs.js";
import CustomArray from "../../../utility/common/CustomArray.js";
import { GuidUtility } from "../../../utility/common/GuidUtility.js";
import { WmtsService } from "./DataSource/WmtsServiceJs.js";
import { OLWMTSConstants } from "../../../utility/common/OLWMTSConstants.js"
import { BaseLayerConfig } from "../../../config/BaseLayerConfig.js";
import { DataSourceInfo } from "./DataSource/DataSourceInfoJs.js";
import { OLSourceType } from "./DataSource/OLSourceTypeJs.js";
import { OLLayerType } from "./DataSource/OLLayerTypeJs.js";
import { XYZService } from "./DataSource/XYZServiceJs.js";
import { SystemConfig } from "../../../config/SystemConfig.js";
//1.创建类 含属性 和 方法
export class TDTServiceInfo {
    constructor() {
        this.id = GuidUtility.getGuid();
        this.index = -1;
        this.name = null;// 服务名称
        this.serviceType = null;// 服务类型 vector、image、 terrain、全景  MapBaseLayerType常量
        this.startLevel = null;// 开始显示级别   
        this.endLevel = null;// 结束显示级别  
        this.opacity = null;// 透明度
        this.serviceFormat = null;// 服务格式--下拉值 就是wmts wms等OLSourceType
        this.serviceSource = new DataSourceInfo();  // 数据源对象 
        this.serviceSourceId = null;// 数据源id
        this.description = null;// 描述  
        this.sort = 0;// 图层排序；
        this.olLayerType = null; //  前端使用 不用存库  取值OLLayerType.js  目前数据源为 wmts 和 wms   对应的图层会是tile
        this.olLayer = null;// 前端使用 不用存库
    }


    //1.2方法：参数含请求路径，请求成功，和失败的回调函数
    create(url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .post(url, this)
            .then(function (response) {
                var responseResult = null;
                //判断是否有响应结果
                if (response) {
                    responseResult = response.data.data;
                }
                //如果请求成功就将结果通过回调函数反馈
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })
            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }
    //update  编辑
    update(url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .put(url, this)
            .then(function (response) {
                var responseResult = null;
                if (response != null) {
                    responseResult = response.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }

            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }
    //将json串转化成对象
    static fromJson(jsonObject) {
        let tdtServiceInfo = null;
        //判断是否传参，为传参返回null
        if (!jsonObject) return tdtServiceInfo;

        tdtServiceInfo = new TDTServiceInfo();
        tdtServiceInfo.id = jsonObject.id;
        tdtServiceInfo.name = jsonObject.name;
        tdtServiceInfo.serviceType = jsonObject.serviceType;
        tdtServiceInfo.startLevel = jsonObject.startLevel;
        tdtServiceInfo.endLevel = jsonObject.endLevel;
        tdtServiceInfo.opacity = jsonObject.opacity;
        tdtServiceInfo.serviceFormat = jsonObject.serviceFormat;
        tdtServiceInfo.serviceSourceId = jsonObject.serviceSourceId;
        if (jsonObject.serviceFormat) {
            //  需要根据不同的数据类型完善该方法
            switch (jsonObject.serviceFormat) {
                case OLSourceType.source_wmts:
                default:
                    tdtServiceInfo.serviceSource = WmtsService.fromJson(jsonObject.serviceSource);// 根据不同类型去解析
                    break;
                case OLSourceType.source_xyz:
                    tdtServiceInfo.serviceSource = XYZService.fromJson(jsonObject.serviceSource);// 根据不同类型去解析
                    break;
            }
        }
        tdtServiceInfo.description = jsonObject.description;
        tdtServiceInfo.sort = jsonObject.sort;
        tdtServiceInfo.olLayerType = TDTServiceInfo.getOlLayerTypeByServiceFormat(jsonObject.serviceFormat);
        return tdtServiceInfo;
    }

    /**
     * @Author: wutt
     * @Date: 2020-11-18 16:07:09
     * @Description: 创建图层
     */
    createLayer(callback) {
        let self = this;
        let serviceSource = this.serviceSource;
        let olLayerType = this.olLayerType;
        let serviceFormat = this.serviceFormat;
        let name = serviceSource.params_value_layer;// 创建图层的图层名称    
        if (!serviceSource) return;
        let vecLayer = null;
        serviceSource.getOLSource(serviceFormat, (source) => {
            vecLayer = TDTServiceInfo.createLayerByOlLayerType(self,olLayerType, source,name);
            callback(vecLayer);
        });
    }
    /**
     * @Author: wutt
     * @Date: 2020-11-18 16:15:30
     * @Description: 根据图层类型分别创建图层
     */
    static createLayerByOlLayerType(tdtServiceInfo,olLayerType, olSource,name) {
        let layer = null;
        if (!tdtServiceInfo || !olLayerType || !olSource || !name) return layer;
        // 需要根据不同的图层类型完善该方法
        switch (olLayerType) {
            case OLLayerType.layer_Tile:
            default:
                layer = TDTServiceInfo.createTileLayer(tdtServiceInfo,olSource, name);
                break;
        }
        return layer;
    }
    /**
     * @Author: wutt
     * @Date: 2020-11-18 16:15:03
     * @Description: 创建矢量图层
     */
    static createTileLayer(tdtServiceInfo,olSource, name) {
        let layer = null;
        if (!tdtServiceInfo || !olSource || !name) return layer;
        layer = new ol.layer.Tile({         
            source: olSource,
            maxZoom:tdtServiceInfo.endLevel,
            minZoom:tdtServiceInfo.startLevel,
            opacity:tdtServiceInfo.opacity
        })
        layer.set(BaseLayerConfig.key_layer_name, name);
        return layer;
    }
    /**
     * @Author: wutt
     * @Date: 2020-11-18 14:27:52
     * @Description: 初始化创建矢量底图
     */
    createAPIVec_cLayer() {
        let source = this.serviceSource;
        let layer = null;
        if (!source) return layer;
        let newUrl = source.joinUrl();
        layer = [
            source.serviceName, newUrl,
            {
                type: "wmts",
                crs: OLWMTSConstants.crs_4326,
                wrapX: false,
                layer: source.serviceName,
                matrixSet: source.matrixSetName,
                format: source.formatName,
                style: BaseLayerConfig.style_name_default,
                origin: source.tileGridOrigin,
                resolutions: source.tileGridResolutions,
                matrixIds: source.tileGridMatrixIds
            }
        ];

        return layer;
    }
    /**
    * @Author: wutt
    * @Date: 2020-11-18 14:27:52
    * @Description: 初始化创建XYZ矢量底图
    */
    createAPITdtXYZVec_cLayer() {
        let source = this.serviceSource;
        let layer = null;
        if (!source) return layer;
        let newUrl = source.joinUrl();
        layer = [
            source.params_value_layer, newUrl,
            {
                type: "TileLayerXYZ",
                crs: OLWMTSConstants.crs_4326,
                origin: source.tileGridOrigin,
                resolutions: source.tileGridResolutions,
                matrixIds: source.tileGridMatrixIds
            }
        ];

        return layer;
    }
    /**
    * @Author: wutt
    * @Date: 2020-11-18 16:01:26
    * @Description: 根据数据格式获取图层类型-----目前不完善需要再补充
    * @param {*} serviceFormat
    */
    static getOlLayerTypeByServiceFormat(serviceFormat) {
        if (!serviceFormat) return;
        let olLayerType = null;
        // 需要根据不同的数据类型完善该方法
        switch (serviceFormat) {
            case OLSourceType.source_wmts:
            case OLSourceType.source_wms:
            case OLSourceType.source_xyz:
            default:
                olLayerType = OLLayerType.layer_Tile;
                break;
        }
        return olLayerType;
    }
}
export class TDTServiceInfos extends CustomArray {
    constructor() {
        super();
    }
    /**
       * @Author: wutt
       * @Date: 2020-11-17 15:02:35
       * @Description: 根据服务类型查询服务集合
       */
    findByType(serviceType) {
        let serviceInfos = new TDTServiceInfos();
        if (!serviceType) return serviceInfos;
        serviceInfos = this.objects.filter((item) => {
            if (item.serviceType == serviceType) return item;
        })
        return serviceInfos;
    }
    /**
     * @Author: wutt
     * @Date: 2020-11-18 16:03:12
     * @Description: 根据图层类型和source创建图层 挂载到对象上
     */
    createLayers() {
        if (this.length == 0) return null;
        let serviceInfo = null;
        for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
            serviceInfo = this.objects[tempIndex];
            if (!serviceInfo) continue;
            serviceInfo.createLayer((layer) => {
                serviceInfo.olLayer = layer;
            });
        }
    }
    //删除
    static deleteMulti(idArray, url, succeedCallback, errorCallback) {
        //let qsParam=qs.stringify({ ids: idArray }, { indices: false });
        let qsParam = idArray.toString();

        AxiosConfig.platform
            .get(url, { params: { ids: qsParam, random: Math.random() } })
            .then(function (response) {
                var responseResult = null;
                if (response != null) {
                    responseResult = response.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {
                if (errorCallback) {

                    errorCallback(error);
                }

            });
    }
    //通过筛选条件查找
    static selectByFilter(filter, url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .post(url, filter)
            .then(function (response) {
                var responseResult = null;
                if (response != null && response.data) {
                    responseResult = response.data.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }

    /**
     * 通过筛选条件查找总数
     * @param {*} filter 
     * @param {*} url 
     * @param {*} succeedCallback 
     * @param {*} errorCallback 
     */
    static selectCountByFilter(filter, url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .post(url, filter)
            .then(function (response) {
                var responseResult = null;
                if (response != null && response.data) {
                    responseResult = response.data.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }


    static fromJsons(jsonObjects) {
        let serviceInfos = new TDTServiceInfos();
        if (!jsonObjects) return serviceInfos;

        let tempJsonItem = null;
        let serviceInfo = null;
        for (let tempIndex = 0; tempIndex < jsonObjects.length; tempIndex++) {
            tempJsonItem = jsonObjects[tempIndex];
            serviceInfo = TDTServiceInfo.fromJson(tempJsonItem);
            if (!serviceInfo) continue;

            serviceInfo.index = tempIndex + 1;

            serviceInfos.push(serviceInfo);
        }

        return serviceInfos;
    }

    /**
     * @Author: wutt
     * @Date: 2020-11-17 17:28:41
     * @Description: 模拟数据
     */
    static mockXYZData() {
        let infos = new Array();
        let wmtsService1 = new XYZService();
        wmtsService1.params_key_layer = "T";
        wmtsService1.params_value_layer ="vec_c";
       // wmtsService1.xyzUrl = ServiceUrlConfig.tdt_xyz_vec_c_url;
        wmtsService1.xyzUrl = ServiceUrlConfig.tdt_xyz_public_base_url;      
        wmtsService1.tileGridExtent = OLWMTSConstants.geoExtent;
        wmtsService1.tileGridOrigin = OLWMTSConstants.epsg4326_origin;
        wmtsService1.tileGridResolutions = OLWMTSConstants.tdt4326_resolutions;
        wmtsService1.tileGridMatrixIds = OLWMTSConstants.tdt4326_matrixIds;
        wmtsService1.tileSize = OLWMTSConstants.tileSize;
        wmtsService1.params_key_x= 'x';
        wmtsService1.params_key_y= "y";
        wmtsService1.params_key_l= "l";
        wmtsService1.params_key_token= "tk";
        wmtsService1.token= SystemConfig.token;
        let wmtsService2 = new XYZService();
        wmtsService2.params_key_layer = "T";
        wmtsService2.params_value_layer = "cva_c";
        wmtsService2.xyzUrl = ServiceUrlConfig.tdt_xyz_public_base_url;
        //wmtsService2.xyzUrl = ServiceUrlConfig.tdt_xyz_cva_c_url;
        wmtsService2.tileGridExtent = OLWMTSConstants.geoExtent;
        wmtsService2.tileGridOrigin = OLWMTSConstants.epsg4326_origin;
        wmtsService2.tileGridResolutions = OLWMTSConstants.tdt4326_resolutionsEx;
        wmtsService2.tileGridMatrixIds = OLWMTSConstants.tdt4326_matrixIds;
        wmtsService2.tileSize = OLWMTSConstants.tileSize;
        wmtsService2.params_key_x= 'x';
        wmtsService2.params_key_y= "y";
        wmtsService2.params_key_l= "l";
        wmtsService2.params_key_token= "tk";
        wmtsService2.token= SystemConfig.token;
        let wmtsService3 = new XYZService();
        wmtsService3.params_key_layer = "T";
        wmtsService3.params_value_layer = "img_c";
        // wmtsService3.xyzUrl = ServiceUrlConfig.tdt_xyz_img_c_url;
        wmtsService3.xyzUrl = ServiceUrlConfig.tdt_xyz_public_base_url;
        wmtsService3.tileGridExtent = OLWMTSConstants.geoExtent;
        wmtsService3.tileGridOrigin = OLWMTSConstants.epsg4326_origin;
        wmtsService3.tileGridResolutions = OLWMTSConstants.tdt4326_resolutionsEx;
        wmtsService3.tileGridMatrixIds = OLWMTSConstants.tdt4326_matrixIds;
        wmtsService3.tileSize = OLWMTSConstants.tileSize;
        wmtsService3.params_key_x= 'x';
        wmtsService3.params_key_y= "y";
        wmtsService3.params_key_l= "l";
        wmtsService3.params_key_token= "tk";
        wmtsService3.token= SystemConfig.token;

        let wmtsService4 = new XYZService();
        wmtsService4.params_key_layer = "T";
        wmtsService4.params_value_layer = "cia_c";
        // wmtsService4.xyzUrl = ServiceUrlConfig.tdt_xyz_cia_c_url;
        wmtsService4.xyzUrl = ServiceUrlConfig.tdt_xyz_public_base_url;
        wmtsService4.tileGridExtent = OLWMTSConstants.geoExtent;
        wmtsService4.tileGridOrigin = OLWMTSConstants.epsg4326_origin;
        wmtsService4.tileGridResolutions = OLWMTSConstants.tdt4326_resolutionsEx;
        wmtsService4.tileGridMatrixIds = OLWMTSConstants.tdt4326_matrixIds;
        wmtsService4.tileSize = OLWMTSConstants.tileSize;
        wmtsService4.params_key_x= 'x';
        wmtsService4.params_key_y= "y";
        wmtsService4.params_key_l= "l";
        wmtsService4.params_key_token= "tk";
        wmtsService4.token= SystemConfig.token;
        let wmtsService5 = new XYZService();
        wmtsService5.params_key_layer = "T";
        wmtsService5.params_value_layer = "ter_c";
       // wmtsService5.xyzUrl = ServiceUrlConfig.tdt_xyz_ter_c_url;
        wmtsService5.xyzUrl = ServiceUrlConfig.tdt_xyz_public_base_url;
        wmtsService5.tileGridExtent = OLWMTSConstants.geoExtent;
        wmtsService5.tileGridOrigin = OLWMTSConstants.epsg4326_origin;
        wmtsService5.tileGridResolutions = OLWMTSConstants.tdt4326_resolutionsEx;
        wmtsService5.tileGridMatrixIds = OLWMTSConstants.tdt4326_matrixIds;
        wmtsService5.tileSize = OLWMTSConstants.tileSize;
        wmtsService5.params_key_x= 'x';
        wmtsService5.params_key_y= "y";
        wmtsService5.params_key_l= "l";
        wmtsService5.params_key_token= "tk";
        wmtsService5.token= SystemConfig.token;
        let wmtsService6 = new XYZService();
        wmtsService6.params_key_layer = "T";
        wmtsService6.params_value_layer = "cta_c";
       // wmtsService6.xyzUrl = ServiceUrlConfig.tdt_xyz_cta_c_url;
        wmtsService6.xyzUrl = ServiceUrlConfig.tdt_xyz_public_base_url;
        wmtsService6.tileGridExtent = OLWMTSConstants.geoExtent;
        wmtsService6.tileGridOrigin = OLWMTSConstants.epsg4326_origin;
        wmtsService6.tileGridResolutions = OLWMTSConstants.tdt4326_resolutionsEx;
        wmtsService6.tileGridMatrixIds = OLWMTSConstants.tdt4326_matrixIds;
        wmtsService6.tileSize = OLWMTSConstants.tileSize;
        wmtsService6.params_key_x= 'x';
        wmtsService6.params_key_y= "y";
        wmtsService6.params_key_l= "l";
        wmtsService6.params_key_token= "tk";
        wmtsService6.token= SystemConfig.token;

        infos = [{
            name: BaseLayerConfig.tdt_layer_vec_c,
            serviceType: 'Vector',
            startLevel: '0',
            endLevel: '18',
            opacity: '1',
            serviceFormat: 'XYZ',
            serviceSource: wmtsService1
        }
            , {
            name: BaseLayerConfig.tdt_layer_cva_c,
            serviceType: 'Vector',
            startLevel: '0',
            endLevel: '18',
            opacity: '1',
            serviceFormat: 'XYZ',
            serviceSource: wmtsService2
        }
            , {
            name: BaseLayerConfig.tdt_layer_img_c,
            serviceType: 'Image',
            startLevel: '0',
            endLevel: '18',
            opacity: '1',
            serviceFormat: 'XYZ',
            serviceSource: wmtsService3
        }, {
            name: BaseLayerConfig.tdt_layer_cia_c,
            serviceType: 'Image',
            startLevel: '0',
            endLevel: '18',
            opacity: '1',
            serviceFormat: 'XYZ',
            serviceSource: wmtsService4
        }, {
            name: BaseLayerConfig.tdt_layer_ter_c,
            serviceType: 'Ter',
            startLevel: '0',
            endLevel: '18',
            opacity: '1',
            serviceFormat: 'XYZ',
            serviceSource: wmtsService5
        }, {
            name: BaseLayerConfig.tdt_layer_cta_c,
            serviceType: 'Ter',
            startLevel: '0',
            endLevel: '18',
            opacity: '1',
            serviceFormat: 'XYZ',
            serviceSource: wmtsService6
        }
        ];
        let retInfos = TDTServiceInfos.fromJsons(infos);
        return retInfos;

    }
}

//典型应用：查看的模型
export class TDTServiceInfoFilter {
    constructor() {
        this.useId = false;
        this.id = null;
        this.useIds = false;
        this.ids = [];
        this.useFuzzyName = false;
        this.fuzzyName = null;

        //类型查询
        this.useServiceType = false;
        this.serviceType = null;

        this.useServiceFormat = false;
        this.serviceFormat = null;

        //分页查询
        this.usePagination = false;
        //每页开始的下标
        this.paginationStart = 0;
        //每页显示的条数
        this.paginationCount = 2;
        this.sourceFilters = [],
        this.useSourceFilters= false;
    }

}



export class TDTServiceInfoFilterResult {
    constructor() {
       //接收的应用的总条数
       this.resourceCount = -1;
       //筛选出的条数
       this.filterResourceCount = -1;
       //筛选出的table数据
       this.tdtServiceInfos = null;
    }
    //将响应的json串转化为对象
    static parseJson(jsonObject) {
        let filterResult = null;
        if (!jsonObject) return filterResult;

        filterResult = new TDTServiceInfoFilterResult();
        //总条数
        filterResult.resourceCount = jsonObject.resourceCount;
        //筛选出的符合条件的条数
        filterResult.filterResourceCount = jsonObject.filterResourceCount;
        //两条对象的数组
        filterResult.tdtServiceInfos = TDTServiceInfos.fromJsons(jsonObject.tdtServiceInfos);

        return filterResult;
    }


    static mock() {
        let json = {};

        json.appCount = 20;
        json.filterAppCount = 2;
        //两条对象数据的数组
        json.filterApps = TDTServiceInfos.mock();

        return json;
    }

}



